import { TimekeepingAction } from '../types';

export interface PendingAction {
    id: string;
    employeeId: string;
    action: TimekeepingAction;
    verificationMethod: string;
    timestamp: string; // ISO string of when it ACTUALLY happened
    location?: {
        lat: number;
        lng: number;
        accuracy?: number;
    };
    geofenceBypassReason?: string;
    photoUrl?: string;
    wifiSSID?: string;
}

const DB_NAME = 'KithHROfflineDB';
const STORE_NAME = 'pending_sync';
const DB_VERSION = 1;

export const openDB = (): Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'id' });
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
};

export const savePendingAction = async (action: Omit<PendingAction, 'id'>) => {
    const db = await openDB();
    const id = crypto.randomUUID();
    return new Promise<void>((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readwrite');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.add({ ...action, id });
        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);
    });
};

export const getPendingActions = async (): Promise<PendingAction[]> => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readonly');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.getAll();
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
};

export const removePendingAction = async (id: string) => {
    const db = await openDB();
    return new Promise<void>((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readwrite');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.delete(id);
        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);
    });
};
